import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "text-left no-printable" }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = {
  key: 2,
  class: "tw-flex tw-h-[3px] tw-mt-4 tw-w-full tw-bg-[#b4b4b4]"
}
const _hoisted_4 = { class: "tw-px-[5em] tw-mt-4 tw-mb-[50px]" }
const _hoisted_5 = { class: "bg-white tw-rounded-xl tw-p-4 mb-4" }
const _hoisted_6 = { class: "tw-bg-white tw-rounded-xl tw-p-4" }
const _hoisted_7 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, "PROPERTY INFORMATION ", -1)
const _hoisted_9 = { class: "tw-px-4" }
const _hoisted_10 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_11 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " TYPE OF PROPERTY ", -1)
const _hoisted_13 = {
  key: 0,
  class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3"
}
const _hoisted_14 = { class: "tw-flex tw-justify-between tw-items-center tw-gap-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY ADDRESSES ", -1)
const _hoisted_20 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_21 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " FINANCING INFORMATION ", -1)
const _hoisted_23 = { class: "tw-px-4" }
const _hoisted_24 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_25 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY PRICE ", -1)
const _hoisted_27 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_30 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " DOWN PAYMENT ", -1)
const _hoisted_32 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_33 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_34 = {
  key: 0,
  class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3"
}
const _hoisted_35 = {
  key: 1,
  class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3"
}
const _hoisted_36 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN AMOUNT ", -1)
const _hoisted_38 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_41 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " INTEREST RATE ", -1)
const _hoisted_43 = {
  key: 0,
  class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3"
}
const _hoisted_44 = {
  key: 1,
  class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3"
}
const _hoisted_45 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_46 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_47 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN YEARS ", -1)
const _hoisted_49 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_52 = {
  key: 0,
  class: "tw-even:bg-gray-50 tw-odd:bg-white"
}
const _hoisted_53 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " LOAN PROGRAM ", -1)
const _hoisted_54 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_56 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_57 = {
  key: 1,
  class: "tw-even:bg-gray-50 tw-odd:bg-white"
}
const _hoisted_58 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PMI ", -1)
const _hoisted_59 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_61 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_62 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY TAXES", -1)
const _hoisted_64 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_67 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PROPERTY INSURANCE", -1)
const _hoisted_69 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_70 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_72 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_73 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FEDERAL TAX", -1)
const _hoisted_74 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_77 = { class: "tw-even:bg-[#eaeaea] tw-odd:bg-white" }
const _hoisted_78 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " FLOOD INSURANCE", -1)
const _hoisted_79 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_82 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_83 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ASSOCIATION PAYMENT ", -1)
const _hoisted_84 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_85 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_86 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_87 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_88 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " OTHERS MONTHLY PAYMENT ", -1)
const _hoisted_89 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_90 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_91 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, null, -1)
const _hoisted_92 = { class: "tw-flex tw-items-center tw-justify-center tw-mt-5 tw-gap-5 tw-text-left tw-mb-8" }
const _hoisted_93 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-px-14" }
const _hoisted_94 = { class: "tw-flex tw-justify-end" }
const _hoisted_95 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_96 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "MONTHLY PAYMENT ", -1)
const _hoisted_97 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_98 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, " CLOSING COST, BROKER AND COMMISSIONS ", -1)
const _hoisted_99 = { class: "tw-px-4" }
const _hoisted_100 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_101 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_102 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " TITLE COMPANY FEES AND SERVICE PAYMENTS ", -1)
const _hoisted_103 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_104 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_105 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BROKER PAYMENT ", -1)
const _hoisted_106 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_107 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_108 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MLO AND UNDERWRITING COMMISSION ", -1)
const _hoisted_109 = { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_110 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_111 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " BUYER AGENT COMMISSION ", -1)
const _hoisted_112 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_113 = { class: "tw-border-[2px] tw-border-[#d2d2d2] tw-mt-5 tw-mb-5 tw-rounded-xl tw-overflow-hidden tw-text-left" }
const _hoisted_114 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-bg-[#00a0da] tw-text-white tw-px-4 tw-pt-2.5 tw-pb-2 tw-text-xl tw-font-semibold" }, "INCOME ", -1)
const _hoisted_115 = { class: "tw-px-4" }
const _hoisted_116 = { class: "tw-w-full table-edit tw-mt-[25px] tw-mb-[25px]" }
const _hoisted_117 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_118 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " MONTHLY PERCENTAGE OCCUPANCY % ", -1)
const _hoisted_119 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_120 = { class: "tw-flex tw-items-center justify-content-center" }
const _hoisted_121 = /*#__PURE__*/_createElementVNode("span", null, "%", -1)
const _hoisted_122 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_123 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " PRICE RENT FOR DAY $ ", -1)
const _hoisted_124 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_125 = { class: "tw-even:bg-gray-50 tw-odd:bg-white" }
const _hoisted_126 = /*#__PURE__*/_createElementVNode("td", { class: "tw-text-center tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }, " ESTIMATE MONTHLY INCOME ", -1)
const _hoisted_127 = { class: "tw-text-left tw-font-normal tw-w-1/4 tw-text-base tw-py-1 tw-px-3" }
const _hoisted_128 = { class: "tw-px-4 tw-mb-[25px]" }
const _hoisted_129 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-3 tw-gap-5" }
const _hoisted_130 = { class: "text-center" }
const _hoisted_131 = /*#__PURE__*/_createElementVNode("label", { for: "" }, "ESTIMATE OF CAPITAL GAIN AND AMORTIZATION OF DEBT", -1)
const _hoisted_132 = { class: "tw-flex tw-justify-center tw-gap-[20px] tw-pb-5" }
const _hoisted_133 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_134 = { class: "tw-flex tw-justify-end" }
const _hoisted_135 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_136 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "TOTAL INVESTMENT ", -1)
const _hoisted_137 = { class: "tw-border-2 tw-border-[#d0d0d0] tw-p-4 tw-rounded-xl tw-mt-4 tw-px-14" }
const _hoisted_138 = { class: "tw-flex tw-justify-end" }
const _hoisted_139 = { class: "tw-flex tw-items-center tw-gap-4" }
const _hoisted_140 = /*#__PURE__*/_createElementVNode("h2", { class: "tw-font-bold tw-text-[#545454] tw-opacity-100 tw-text-sm" }, "AVERAGE NET PROFIT OVER 5 YEARS (%) ", -1)
const _hoisted_141 = { class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tx-center tw-h-[40px] tw-w-[150px] tw-px-3" }
const _hoisted_142 = { class: "tw-flex tw-justify-center tw-items-center tw-mt-7 tw-gap-5 tw-mb-5 tw-w-full" }

import { ref, toRefs, computed } from 'vue';
import axios from 'axios';
import UserService from "@/shared/services/user.service";
import { environment } from "@/environment";
import { currencyFormat } from '@/composables/filters';
import { useToast } from "@/composables/useToast";
import ResidentialView from "./../ResidentialView.vue";
import VueNumberFormat from "vue-number-format";
import FindA from "@/components/admin/Residential/FindA/FindA.vue";
import MLO from "@/components/admin/Residential/MLO/MLO.vue";
import MLOforeignInvestment from '@/components/admin/Residential/MLO/MLOforeignInvestment.vue';
import SheetShortFinancing from '../economicSheet/SheetShortFinancing.vue';
import SheetForeignShortFinancing from '../economicSheet/SheetForeignShortFinancing.vue';

// Props

export default /*#__PURE__*/_defineComponent({
  __name: 'ShortTermFinancing',
  props: {
  header: {
    type: Boolean,
    default: true,
  },
  foreign: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const toast = useToast();

// Components


const { header, foreign } = toRefs(props);

// Declare missing refs
const listPropertyTypes = ref([]);
const selectPropertys = ref([{
  value: null,
  label: 'SELECT PROPERTY'
},
{
  value: 'investment',
  label: 'INVESTMENT'
}]);
const selectPrograms = ref([
  {
    value: null,
    label: 'SELECT PROGRAM'
  },
  {
    value: 'conventional',
    label: 'CONVENTIONAL'
  }
]);
const shortTerm = ref({
  pmi: 0,
  mortgage: 0,
  propertyPrice: 0,
  propertyType: null,
  propertyAddress: '',
  propertyClosingCostBuy: 0,
  propertyEstimateRent: 0,
  propertyEstimateCapitalGain: 0,
  propertyAnnualNetProfit: '',
  propertyAverageNetProfitYears: '',
  propertyAssociationPaymentTax: 0,
  propertyBrokerPayment: 0,
  propertyOtherMonthlyPayment: 0,
  propertyTaxes: 0,
  propertyStateTaxes: 0,
  propertyInsurance: 0,
  propertyDownPayment: 0,
  propertyEstimateLoan: 0,
  propertyFloodInsurance: 0,
  stateTaxes: 0,
  propertyMonthlyPercentageOccupancy: 0,
  propertyRentDay: 0,
});

// Existing refs
const url = environment.URL_API;
const loading = ref(false);
const scenarioValid = ref(false);
const userSession = ref(null);
const selectedMLO = ref(null);
const selectedCompanyTitle = ref(null);
const selectedInspector = ref(null);
const buyer_agents_commission = ref(0)

const customer = ref({
  name: '',
  phone: '',
  email: ''
});

// Methods
const getSession = () => {
  let session =
    localStorage.getItem("usersession") &&
      localStorage.getItem("usersession").length > 0
      ? JSON.parse(localStorage.getItem("usersession"))
      : null;

  if (session) {
    userSession.value = session;
  } else {
    UserService.logout("Session expired!");
  }
};

// Computed
const loanAmount = computed(() => {
  let result = 0
  if (shortTerm.value.propertyPrice !== 0) {
    result = shortTerm.value.propertyPrice - shortTerm.value.propertyDownPayment
  }
  return parseFloat(result.toFixed(0))
})

const PriceDownpayment = computed(() => {
  let result = 0
  if (shortTerm.value.propertyPrice !== 0 && selectedMLO.value !== null && !foreign.value) {
    result = shortTerm.value.propertyPrice * (selectedMLO.value.minimumDownPayment / 100)
  }
  if (shortTerm.value.propertyPrice !== 0 && selectedMLO.value !== null && foreign.value) {
    result = shortTerm.value.propertyPrice * (selectedMLO.value.down_payment / 100)
  }
  return parseFloat(result.toFixed(0))
})

const pmi = computed(() => {

  let result = 0
  if (!foreign.value && selectedMLO.value !== null) {
    const percentage = shortTerm.value.propertyDownPayment / shortTerm.value.propertyPrice
    const percentageTwo = parseFloat(percentage.toFixed(2))
    const valueMinimumDown = selectedMLO.value.minimumDownPayment / 100
    if (percentageTwo < parseFloat(valueMinimumDown.toFixed(2))) {
      result = ((selectedMLO.value.PMI / 100) * loanAmount.value) / 12
    }
  }
  return result !== 0 ? parseFloat((result).toFixed(0)) : result
})

const propertyFloodInsurance = computed(() => {
  let result = 0
  if (shortTerm.value.propertyFloodInsurance !== 0) {
    result = ((shortTerm.value.propertyFloodInsurance / 100) * shortTerm.value.propertyPrice / 12)
  }
  return parseFloat(result.toFixed(0))
})

const propertyTaxes = computed(() => {
  let result = 0
  if (shortTerm.value.propertyPrice !== 0) {
    result = (shortTerm.value.propertyPrice * (shortTerm.value.propertyTaxes / 100) / 12)
  }
  return parseFloat(result.toFixed(0))
})

const federalTaxes = computed(() => {
  let result = 0
  if (shortTerm.value.propertyPrice !== 0) {
    result = (shortTerm.value.propertyPrice * (shortTerm.value.stateTaxes / 100) / 12)
  }
  return parseFloat(result.toFixed(0))
})

const propertyInsurance = computed(() => {
  let result = 0
  if (shortTerm.value.propertyPrice !== 0) {
    result = (shortTerm.value.propertyPrice * (shortTerm.value.propertyInsurance / 100) / 12)
  }
  return parseFloat(result.toFixed(0))
})

const companyFeesAndServices = computed(() => {
  let result = 0
  const buyer = (selectedCompanyTitle.value?.buyer || 0) / 100;
  result = shortTerm.value.propertyPrice * buyer;
  return parseFloat(result.toFixed(0))
});

const buyerAgentCommission = computed(() => {
  let result = 0
  if (shortTerm.value.propertyPrice !== 0) {
    result = (shortTerm.value.propertyPrice * (buyer_agents_commission.value / 100))
  }
  return parseFloat(result.toFixed(0))

});

const mloAndUnderwriting = computed(() => {
  let result = 0
  if (selectedMLO.value !== null) {
    const underwriting = selectedMLO.value.underwritingCommission?.mlo_commission / 100
    result = (loanAmount.value * underwriting)
  }
  return parseFloat(result.toFixed(0))
});

const capitalGain = computed(() => {
  let result = 0
  if (shortTerm.value.propertyType !== null) {
    result = ((shortTerm.value.propertyPrice * (shortTerm.value.propertyType.value / 100)) * 5) + (loanAmount.value * (5.9 / 100))
  }
  return parseFloat(result.toFixed(0))
});

const totalCapitalGain = computed(() => {
  return shortTerm.value.propertyEstimateRent + capitalGain.value
});

const monthlyPayment = computed(() => {
  let result = 0
  let years = 1;
  if (selectedMLO.value !== null) {
    years = selectedMLO.value.filters.year * 12
  }
  if (selectedMLO.value !== null && !foreign.value) {
    const interestRateRatio = ((selectedMLO.value.interestRate || 0) / 100) / 12

    const calcTop = interestRateRatio * loanAmount.value
    const calcBottom = 1 - (1 / Math.pow(1 + interestRateRatio, years))

    const interest = loanAmount.value * interestRateRatio
    const capital = calcTop / calcBottom - interest
    result = capital + interest
  }
  if (selectedMLO.value !== null && foreign.value) {
    const interestRateRatio = ((selectedMLO.value.interest_rate || 0) / 100) / 12

    const calcTop = interestRateRatio * loanAmount.value
    const calcBottom = 1 - (1 / Math.pow(1 + interestRateRatio, years))

    const interest = loanAmount.value * interestRateRatio
    const capital = calcTop / calcBottom - interest
    result = capital + interest
  }
  return parseFloat(result.toFixed(2))
})

const totalMonthly = computed(() => {
  let result = 0
  result = monthlyPayment.value + propertyTaxes.value + federalTaxes.value + propertyFloodInsurance.value + propertyInsurance.value + pmi.value + shortTerm.value.propertyAssociationPaymentTax + shortTerm.value.propertyOtherMonthlyPayment

  return parseFloat(result.toFixed(2))
})

const profit = computed(() => {
  return totalCapitalGain.value - totalMonthly.value
});

const totalIncome = computed(() => {
  let totalIncome = 0
  if (shortTerm.value.propertyPrice !== null) {
    totalIncome = (capitalGain.value + ((estimateMonthlyIncome.value * 12) * 5))
  }
  return totalIncome
});

const totalExpenses = computed(() => {
  return (
    (monthlyPayment.value * 12 * 5) +
    (propertyTaxes.value * 12 * 5) +
    (propertyInsurance.value * 12 * 5) +
    (federalTaxes.value * 12 * 5) +
    (propertyFloodInsurance.value * 12 * 5) +
    (pmi.value * 12 * 5) +
    (shortTerm.value.propertyAssociationPaymentTax * 12 * 5) +
    (shortTerm.value.propertyOtherMonthlyPayment * 12 * 5))
});

const netProfitPercent = computed(() => {
  console.log("income", totalIncome.value)
  console.log("expenses", totalExpenses.value)
  console.log("investment", totalInversment.value)
  console.log("resta", totalIncome.value - totalExpenses.value)
  console.log("division", (totalIncome.value - totalExpenses.value) / totalInversment.value)
  console.log("-----------------------------------------------------------")
  const result = ((totalIncome.value - totalExpenses.value) / totalInversment.value) * 100
  return result > 0 ? (result).toFixed(0) : 0
});

const totalInversment = computed(() => {
  return shortTerm.value.propertyDownPayment + shortTerm.value.propertyBrokerPayment + companyFeesAndServices.value + buyerAgentCommission.value + mloAndUnderwriting.value
});

const monthlyPercentageOccupancyValue = computed(() => {
  if (shortTerm.value.propertyMonthlyPercentageOccupancy) {
    return (shortTerm.value.propertyMonthlyPercentageOccupancy / 100) * (365 / 12);
  }
  return null;
});

const estimateMonthlyIncome = computed(() => {
  if (shortTerm.value.propertyRentDay && monthlyPercentageOccupancyValue.value) {
    return shortTerm.value.propertyRentDay * monthlyPercentageOccupancyValue.value;
  }
  return null;
});

const getRealtorForm = async () => {
  loading.value = true;
  const response = await axios(
    `${url}realtor-format?user_id=${userSession.value.iduser}`,
    {
      method: "GET",
    }
  );
  if (!response.data.error) {
    shortTerm.value.propertyBrokerPayment = response.data.commissions.real_estate_broker_fee || 0;
    listPropertyTypes.value = [{
      name: 'TOWN HOUSE',
      value: response.data.annualAverageCapitalGain.town_house || 0,
    },
    {
      name: 'CONDO',
      value: response.data.annualAverageCapitalGain.condo || 0,
    },
    {
      name: 'SINGLE HOUSE',
      value: response.data.annualAverageCapitalGain.single_house || 0,
    },
    {
      name: 'VILLA',
      value: response.data.annualAverageCapitalGain.villa || 0,
    },
    {
      name: 'MOBILE',
      value: response.data.annualAverageCapitalGain.mobile || 0,
    },
    {
      name: 'OTHERS',
      value: response.data.annualAverageCapitalGain.others || 0,
    }];
    if (response.data.averageTaxesAndInsurance) {
      shortTerm.value.propertyTaxes = response.data.averageTaxesAndInsurance.property_taxes
      shortTerm.value.stateTaxes = response.data.averageTaxesAndInsurance.federal_taxes
      shortTerm.value.propertyInsurance = response.data.averageTaxesAndInsurance.property_insurance
      shortTerm.value.propertyFloodInsurance = response.data.averageTaxesAndInsurance.property_flood_insurance
    }
    if (response.data.commissions) {
      buyer_agents_commission.value = response.data.commissions.buyer_agent_commission
    }
  }
  loading.value = false;
};

// Add missing methods
const calculatePropertyEstimateCapitalGain = () => {
  const price = shortTerm.value.propertyPrice || 0;
  const typeMultiplier = shortTerm.value.propertyType.value || 0;
  shortTerm.value.propertyEstimateCapitalGain = ((price * typeMultiplier) / 100) * 5;
};

const submitScenario = async () => {
  loading.value = true;
  if (!foreign.value) {
    const response = await axios(`${url}realtor-short-financing`, {
      method: "POST",
      data: {
        realtorShortFinancing: [{
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "SHORT FINANCING",
          propertyType: shortTerm.value.propertyType?.value,
          propertyadresses: shortTerm.value.propertyAddress,
          propertyPrice: shortTerm.value.propertyPrice,
          downPayment: shortTerm.value.propertyDownPayment,
          loanAmount: loanAmount.value,
          loanProgram: selectedMLO.value.filters.program,
          interestRate: selectedMLO.value.interestRate,
          loanYears: selectedMLO.value.filters.year,
          pmi: pmi.value,
          propertyTaxes: propertyTaxes.value,
          propertyInsurance: propertyInsurance.value,
          federalTaxes: federalTaxes.value,
          floodInsurance: propertyFloodInsurance.value,
          associationPayment: shortTerm.value.propertyAssociationPaymentTax,
          otherMonthlyPayment: shortTerm.value.propertyOtherMonthlyPayment,
          monthlyPayment: totalMonthly.value,
          companyFeesAndServices: companyFeesAndServices.value,
          brokerPayment: shortTerm.value.propertyBrokerPayment,
          mloUnderwriting: mloAndUnderwriting.value,
          buyerAgentComission: buyerAgentCommission.value,
          monthlypercentage: shortTerm.value.propertyMonthlyPercentageOccupancy,
          priceForDay: shortTerm.value.propertyRentDay,
          estimateIncome: estimateMonthlyIncome.value,
          capitalGain: capitalGain.value,
          totalInvestment: totalInversment.value,
          averageNet: netProfitPercent.value,
          client_name: customer.value.name,
          client_email: customer.value.email
        }],
        customer: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "SHORT FINANCING",
          name: customer.value.name,
          phone: customer.value.phone,
          email: customer.value.email
        },
        mloSelected: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "SHORT FINANCING",
          name: selectedMLO.value.realtorMLOData.name,
          lastname: selectedMLO.value.realtorMLOData.lastname,
          phone: selectedMLO.value.realtorMLOData.phone,
          email: selectedMLO.value.realtorMLOData.email,
          program: selectedMLO.value.filters.program,
          interestRate: selectedMLO.value.interestRate,
          minimumDownPayment: selectedMLO.value.minimumDownPayment,
          pmi: selectedMLO.value.PMI,
          backEndRatio: selectedMLO.value.backEndRatio,
          maximumLoanAmount: selectedMLO.value.maximumLoanAmount,
          client_name: customer.value.name,
          client_email: customer.value.email
        },
      }
    });

    if (!response.data.error) {
      loading.value = false;
      await toast.success(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    } else {
      loading.value = false;
      await toast.error(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  } else {
    const response = await axios(`${url}realtor-short-financing`, {
      method: "POST",
      data: {
        realtorShortFinancing: [{
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FOREIGN SHORT FINANCING",
          propertyType: shortTerm.value.propertyType?.value,
          propertyadresses: shortTerm.value.propertyAddress,
          propertyPrice: shortTerm.value.propertyPrice,
          downPayment: shortTerm.value.propertyDownPayment,
          loanAmount: loanAmount.value,
          loanProgram: selectedMLO.value.filters.program,
          interestRate: selectedMLO.value.interest_rate,
          loanYears: selectedMLO.value.filters.year,
          pmi: pmi.value,
          propertyTaxes: propertyTaxes.value,
          propertyInsurance: propertyInsurance.value,
          federalTaxes: federalTaxes.value,
          floodInsurance: propertyFloodInsurance.value,
          associationPayment: shortTerm.value.propertyAssociationPaymentTax,
          otherMonthlyPayment: shortTerm.value.propertyOtherMonthlyPayment,
          monthlyPayment: totalMonthly.value,
          companyFeesAndServices: companyFeesAndServices.value,
          brokerPayment: shortTerm.value.propertyBrokerPayment,
          mloUnderwriting: mloAndUnderwriting.value,
          buyerAgentComission: buyerAgentCommission.value,
          monthlypercentage: shortTerm.value.propertyMonthlyPercentageOccupancy,
          priceForDay: shortTerm.value.propertyRentDay,
          estimateIncome: estimateMonthlyIncome.value,
          capitalGain: capitalGain.value,
          totalInvestment: totalInversment.value,
          averageNet: netProfitPercent.value,
          client_name: customer.value.name,
          client_email: customer.value.email
        }],
        customer: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FOREIGN SHORT FINANCING",
          name: customer.value.name,
          phone: customer.value.phone,
          email: customer.value.email
        },
        mloSelected: {
          ID: null,
          user_id: userSession.value.iduser,
          scenario_type: "FOREIGN SHORT FINANCING",
          name: selectedMLO.value.realtorMLOData.name,
          lastname: selectedMLO.value.realtorMLOData.lastname,
          phone: selectedMLO.value.realtorMLOData.phone,
          email: selectedMLO.value.realtorMLOData.email,
          program: selectedMLO.value.filters.program,
          interestRate: selectedMLO.value.interest_rate,
          minimumDownPayment: selectedMLO.value.down_payment,
          pmi: selectedMLO.value.PMI,
          backEndRatio: selectedMLO.value.backEndRatio,
          maximumLoanAmount: selectedMLO.value.maximumLoanAmount,
          client_name: customer.value.name,
          client_email: customer.value.email
        },
      }
    });

    if (!response.data.error) {
      loading.value = false;
      await toast.success(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    } else {
      loading.value = false;
      await toast.error(response.data.message, {
        position: "top-end",
        timer: 3000,
        showCloseButton: true,
      });
    }
  }
}

const updateParentCompanyTitle = (newCompanyTitle: any) => {
  selectedCompanyTitle.value = newCompanyTitle;
};

const updateParentInspector = (newInspector: any) => {
  selectedInspector.value = newInspector;
};

// Initialize component
getSession();
getRealtorForm();

return (_ctx: any,_cache: any) => {
  const _component_TopBar = _resolveComponent("TopBar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(foreign))
      ? (_openBlock(), _createBlock(_component_TopBar, {
          key: 0,
          helpBar: true,
          helpDescription: "Video tutorial",
          helpVideo: "https://www.realtortools.org/media/Video%20Short%20Term%20Financing.mp4"
        }))
      : _createCommentVNode("", true),
    (!_unref(foreign))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(ResidentialView, { header: false })
        ]))
      : _createCommentVNode("", true),
    (!_unref(foreign))
      ? (_openBlock(), _createElementBlock("p", _hoisted_3))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (!_unref(foreign))
        ? (_openBlock(), _createBlock(SheetShortFinancing, { key: 0 }))
        : _createCommentVNode("", true),
      (_unref(foreign))
        ? (_openBlock(), _createBlock(SheetForeignShortFinancing, { key: 1 }))
        : _createCommentVNode("", true),
      _createVNode(FindA, {
        userSession: userSession.value,
        selectedCompanyTitle: selectedCompanyTitle.value,
        usingInspector: selectedInspector.value,
        isInvestment: true,
        "onUpdate:selectedCompanyTitle": updateParentCompanyTitle,
        "onUpdate:usingInspector": updateParentInspector
      }, null, 8, ["userSession", "selectedCompanyTitle", "usingInspector"]),
      _createElementVNode("div", _hoisted_5, [
        (!_unref(foreign))
          ? (_openBlock(), _createBlock(MLO, {
              key: 0,
              title: "SHORT TERM FINANCING INVESTMENT",
              userSession: userSession.value,
              usingMLO: selectedMLO.value,
              "onUpdate:usingMLO": _cache[0] || (_cache[0] = ($event: any) => ((selectedMLO).value = $event)),
              customer: customer.value,
              selectPropertys: selectPropertys.value,
              selectPrograms: selectPrograms.value
            }, null, 8, ["userSession", "usingMLO", "customer", "selectPropertys", "selectPrograms"]))
          : _createCommentVNode("", true),
        (_unref(foreign))
          ? (_openBlock(), _createBlock(MLOforeignInvestment, {
              key: 1,
              title: "SHORT TERM FINANCING INVESTMENT",
              userSession: userSession.value,
              usingMLO: selectedMLO.value,
              "onUpdate:usingMLO": _cache[1] || (_cache[1] = ($event: any) => ((selectedMLO).value = $event)),
              customer: customer.value,
              selectPropertys: selectPropertys.value,
              selectPrograms: selectPrograms.value
            }, null, 8, ["userSession", "usingMLO", "customer", "selectPropertys", "selectPrograms"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("table", _hoisted_10, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_11, [
                  _hoisted_12,
                  (listPropertyTypes.value.length > 0)
                    ? (_openBlock(), _createElementBlock("td", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _withDirectives(_createElementVNode("select", {
                            name: "",
                            id: "",
                            class: "form-control tw-full",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((shortTerm.value.propertyType) = $event)),
                            onChange: calculatePropertyEstimateCapitalGain
                          }, [
                            _hoisted_15,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listPropertyTypes.value, (property) => {
                              return (_openBlock(), _createElementBlock("option", { value: property }, _toDisplayString(property.name), 9, _hoisted_16))
                            }), 256))
                          ], 544), [
                            [_vModelSelect, shortTerm.value.propertyType]
                          ]),
                          (shortTerm.value.propertyType)
                            ? (_openBlock(), _createElementBlock("input", {
                                key: 0,
                                type: "text",
                                value: (shortTerm.value.propertyType.value ? shortTerm.value.propertyType.value + '%' : ''),
                                disabled: ""
                              }, null, 8, _hoisted_17))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("tr", _hoisted_18, [
                  _hoisted_19,
                  _createElementVNode("td", _hoisted_20, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shortTerm.value.propertyAddress) = $event))
                    }, null, 512), [
                      [_vModelText, shortTerm.value.propertyAddress]
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("table", _hoisted_24, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("td", _hoisted_27, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyPrice",
                      value: shortTerm.value.propertyPrice,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((shortTerm.value.propertyPrice) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' },
                      onChange: calculatePropertyEstimateCapitalGain
                    }, null, 8, ["value", "options"])
                  ]),
                  _hoisted_28,
                  _hoisted_29
                ]),
                _createElementVNode("tr", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("td", _hoisted_32, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyDownPayment",
                      value: shortTerm.value.propertyDownPayment,
                      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((shortTerm.value.propertyDownPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ]),
                  _createElementVNode("td", _hoisted_33, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "downPayment",
                      value: PriceDownpayment.value,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((PriceDownpayment).value = $event)),
                      options: {
                      precision: 0,
                      prefix: '$ ',
                      thousand: ',',
                      acceptNegative: false,
                      isInteger: true,
                      decimal: '.',
                    }
                    }, null, 8, ["value", "options"])
                  ]),
                  (!_unref(foreign))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_34, _toDisplayString(selectedMLO.value !== null
                        ? selectedMLO.value.minimumDownPayment
                        : "") + " % ", 1))
                    : _createCommentVNode("", true),
                  (_unref(foreign))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_35, _toDisplayString(selectedMLO.value !== null
                        ? selectedMLO.value.down_payment
                        : "") + " % ", 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("tr", _hoisted_36, [
                  _hoisted_37,
                  _createElementVNode("td", _hoisted_38, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyEstimateLoan",
                      value: loanAmount.value,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((loanAmount).value = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: true, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ]),
                  _hoisted_39,
                  _hoisted_40
                ]),
                _createElementVNode("tr", _hoisted_41, [
                  _hoisted_42,
                  (!_unref(foreign))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_43, _toDisplayString(selectedMLO.value !== null
                        ? selectedMLO.value.interestRate
                        : "") + " % ", 1))
                    : _createCommentVNode("", true),
                  (_unref(foreign))
                    ? (_openBlock(), _createElementBlock("td", _hoisted_44, _toDisplayString(selectedMLO.value !== null
                        ? selectedMLO.value.interest_rate
                        : "") + " % ", 1))
                    : _createCommentVNode("", true),
                  _hoisted_45,
                  _hoisted_46
                ]),
                _createElementVNode("tr", _hoisted_47, [
                  _hoisted_48,
                  _createElementVNode("td", _hoisted_49, _toDisplayString(selectedMLO.value !== null
                        ? selectedMLO.value.filters.year
                        : ""), 1),
                  _hoisted_50,
                  _hoisted_51
                ]),
                (!_unref(foreign))
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                      _hoisted_53,
                      _createElementVNode("td", _hoisted_54, _toDisplayString(selectedMLO.value !== null
                        ? selectedMLO.value.filters.program
                        : ""), 1),
                      _hoisted_55,
                      _hoisted_56
                    ]))
                  : _createCommentVNode("", true),
                (!_unref(foreign))
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_57, [
                      _hoisted_58,
                      _createElementVNode("td", _hoisted_59, " $ " + _toDisplayString(pmi.value !== null ? Math.round(pmi.value).toLocaleString() : ''), 1),
                      _hoisted_60,
                      _hoisted_61
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("tr", _hoisted_62, [
                  _hoisted_63,
                  _createElementVNode("td", _hoisted_64, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "monthlypayment",
                      value: propertyTaxes.value,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((propertyTaxes).value = $event)),
                      options: {
                      precision: 0,
                      prefix: '$ ',
                      thousand: ',',
                      acceptNegative: true,
                      isInteger: false,
                      decimal: '.',
                    }
                    }, null, 8, ["value", "options"])
                  ]),
                  _hoisted_65,
                  _hoisted_66
                ]),
                _createElementVNode("tr", _hoisted_67, [
                  _hoisted_68,
                  _createElementVNode("td", _hoisted_69, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "monthlypayment",
                      value: propertyInsurance.value,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((propertyInsurance).value = $event)),
                      options: {
                      precision: 0,
                      prefix: '$ ',
                      thousand: ',',
                      acceptNegative: true,
                      isInteger: false,
                      decimal: '.',
                    }
                    }, null, 8, ["value", "options"])
                  ]),
                  _hoisted_70,
                  _hoisted_71
                ]),
                _createElementVNode("tr", _hoisted_72, [
                  _hoisted_73,
                  _createElementVNode("td", _hoisted_74, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "monthlypayment",
                      value: federalTaxes.value,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((federalTaxes).value = $event)),
                      options: {
                      precision: 0,
                      prefix: '$ ',
                      thousand: ',',
                      acceptNegative: true,
                      isInteger: false,
                      decimal: '.',
                    }
                    }, null, 8, ["value", "options"])
                  ]),
                  _hoisted_75,
                  _hoisted_76
                ]),
                _createElementVNode("tr", _hoisted_77, [
                  _hoisted_78,
                  _createElementVNode("td", _hoisted_79, _toDisplayString(_unref(currencyFormat)(propertyFloodInsurance.value)), 1),
                  _hoisted_80,
                  _hoisted_81
                ]),
                _createElementVNode("tr", _hoisted_82, [
                  _hoisted_83,
                  _createElementVNode("td", _hoisted_84, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "association",
                      value: shortTerm.value.propertyAssociationPaymentTax,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((shortTerm.value.propertyAssociationPaymentTax) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ]),
                  _hoisted_85,
                  _hoisted_86
                ]),
                _createElementVNode("tr", _hoisted_87, [
                  _hoisted_88,
                  _createElementVNode("td", _hoisted_89, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "otherMontlhyPayment",
                      value: shortTerm.value.propertyOtherMonthlyPayment,
                      "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((shortTerm.value.propertyOtherMonthlyPayment) = $event)),
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ]),
                  _hoisted_90,
                  _hoisted_91
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_92, [
          _createElementVNode("div", _hoisted_93, [
            _createElementVNode("div", _hoisted_94, [
              _createElementVNode("div", _hoisted_95, [
                _hoisted_96,
                _createVNode(_unref(VueNumberFormat), {
                  id: "association",
                  value: totalMonthly.value,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((totalMonthly).value = $event)),
                  options: {
                  precision: 0,
                  prefix: '$ ',
                  thousand: ',',
                  acceptNegative: false,
                  isInteger: false,
                  decimal: '.',
                },
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tw-h-[40px] tw-px-3"
                }, null, 8, ["value", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_97, [
          _hoisted_98,
          _createElementVNode("div", _hoisted_99, [
            _createElementVNode("table", _hoisted_100, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_101, [
                  _hoisted_102,
                  _createElementVNode("td", _hoisted_103, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyBrokerPayment",
                      value: companyFeesAndServices.value,
                      "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((companyFeesAndServices).value = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_104, [
                  _hoisted_105,
                  _createElementVNode("td", _hoisted_106, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyBrokerPayment",
                      value: shortTerm.value.propertyBrokerPayment,
                      "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((shortTerm.value.propertyBrokerPayment) = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_107, [
                  _hoisted_108,
                  _createElementVNode("td", _hoisted_109, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyBrokerPayment",
                      value: mloAndUnderwriting.value,
                      "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((mloAndUnderwriting).value = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_110, [
                  _hoisted_111,
                  _createElementVNode("td", _hoisted_112, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyBrokerPayment",
                      value: buyerAgentCommission.value,
                      "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((buyerAgentCommission).value = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_113, [
          _hoisted_114,
          _createElementVNode("div", _hoisted_115, [
            _createElementVNode("table", _hoisted_116, [
              _createElementVNode("tbody", null, [
                _createElementVNode("tr", _hoisted_117, [
                  _hoisted_118,
                  _createElementVNode("td", _hoisted_119, [
                    _createElementVNode("div", _hoisted_120, [
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((shortTerm.value.propertyMonthlyPercentageOccupancy) = $event))
                      }, null, 512), [
                        [_vModelText, shortTerm.value.propertyMonthlyPercentageOccupancy]
                      ]),
                      _hoisted_121
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_122, [
                  _hoisted_123,
                  _createElementVNode("td", _hoisted_124, [
                    _createElementVNode("div", null, [
                      _createVNode(_unref(VueNumberFormat), {
                        id: "propertyRentDay",
                        value: shortTerm.value.propertyRentDay,
                        "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((shortTerm.value.propertyRentDay) = $event)),
                        options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: true, isInteger: true, decimal: '.' }
                      }, null, 8, ["value", "options"])
                    ])
                  ])
                ]),
                _createElementVNode("tr", _hoisted_125, [
                  _hoisted_126,
                  _createElementVNode("td", _hoisted_127, [
                    _createVNode(_unref(VueNumberFormat), {
                      id: "propertyEstimateMonthlyIncome",
                      value: estimateMonthlyIncome.value,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((estimateMonthlyIncome).value = $event)),
                      disabled: "",
                      options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: false, decimal: '.' }
                    }, null, 8, ["value", "options"])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_128, [
            _createElementVNode("div", _hoisted_129, [
              _createElementVNode("div", _hoisted_130, [
                _hoisted_131,
                _createVNode(_unref(VueNumberFormat), {
                  id: "propertyEstimateCapitalGain",
                  class: "tw-w-full tw-outline-none tw-h-[45px] tw-border tw-border-[#b6b6b6] tw-rounded-lg tw-overflow-hidden tw-px-4 tw-mt-0.5",
                  value: capitalGain.value,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((capitalGain).value = $event)),
                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                }, null, 8, ["value", "options"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_132, [
          _createElementVNode("div", _hoisted_133, [
            _createElementVNode("div", _hoisted_134, [
              _createElementVNode("div", _hoisted_135, [
                _hoisted_136,
                _createVNode(_unref(VueNumberFormat), {
                  id: "propertyEstimateInvestment",
                  class: "tw-bg-[#E6E7E9] tw-border-none tw-rounded-md tw-outline-none tx-center tw-h-[40px] tw-w-[150px] tw-px-3",
                  value: totalInversment.value,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((totalInversment).value = $event)),
                  options: { precision: 0, prefix: '$ ', thousand: ',', acceptNegative: false, isInteger: true, decimal: '.' }
                }, null, 8, ["value", "options"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_137, [
            _createElementVNode("div", _hoisted_138, [
              _createElementVNode("div", _hoisted_139, [
                _hoisted_140,
                _createElementVNode("div", _hoisted_141, _toDisplayString(netProfitPercent.value) + " % ", 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_142, [
          _createElementVNode("button", {
            onClick: _cache[23] || (_cache[23] = ($event: any) => (submitScenario())),
            class: "tw-bg-[#78c18a] tw-text-white tw-h-[40px] tw-font-bold tw-w-[250px] tw-rounded-full tw-text-xl"
          }, "SAVE & REGISTER")
        ])
      ])
    ])
  ]))
}
}

})